import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { durationReportFormatter } from "../../fomatters/DateFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

const groupByMap = {
  0: "User",
  1: "Player",
  2: "Station",
};

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function SummaryCallActivity() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [startTime, setStartTime] = useState("00:00");
  const onStartTimeChange = useCallback(
    (event) => setStartTime(event.target.value),
    []
  );

  const [endTime, setEndTime] = useState("00:00");
  const onEndTimeChange = useCallback(
    (event) => setEndTime(event.target.value),
    []
  );

  const [player, setPlayer] = useState("");
  const onPlayerChanged = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );

  const [agent, setAgent] = useState("");
  const onAgentChanged = useCallback(
    (event) => setAgent(event.target.value),
    []
  );

  const [selection, setSelection] = useState(0);
  const onSelectionChange = useCallback(
    (event) => setSelection(Number(event.target.value)),
    []
  );

  const [groupBy, setGroupBy] = useState(0);
  const onGroupByChange = useCallback(
    (event) => setGroupBy(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [user, setUser] = useState("");
  const onUserChange = useCallback((u) => setUser(u), []);
  const { values: users } = useDataFormatterHook({
    addEmpty: true,
    value: "loginName",
    text: "loginName",
    path: `/User/GetUsers`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="Start Time"
          type="time"
          value={startTime}
          size="small"
          inputMode=""
          onChange={onStartTimeChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="End Time"
          type="time"
          value={endTime}
          size="small"
          onChange={onEndTimeChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Player"
          type="text"
          value={player}
          size="small"
          onChange={onPlayerChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent"
          type="text"
          value={agent}
          size="small"
          onChange={onAgentChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="User"
          name="name"
          data={users}
          placeholder="DataFormatter"
          setSelectValue={onUserChange}
          startValue={""}
        />
        <div>
          <SubGroup title="Summary By">
            <FormControl component="fieldset">
              <RadioGroup label value={groupBy} onChange={onGroupByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="User"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Player"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Station"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Select Only">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={selection}
                onChange={onSelectionChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Phone"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="OnLine"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Summary Call Activity"
        getUrl={() => "/Reports/Report_Summary_Call_Activity_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          StartTime: startTime,
          EndTime: endTime,
          Book: book,
          Group: group,
          Player: player,
          Agent: agent,
          User: user,
          GroupBy: groupBy,
          Selection: selection,
        })}
        getProcess={(data) =>
          data.map((item) => ({
            ...item,
            timePerCall: item.numCalls > 0 ? item.numSeg / item.numCalls : 0,
            timePerWager: item.numBet > 0 ? item.numSeg / item.numBet : 0,
          }))
        }
        getTotals={(data) => ({
          id: "Totals",
          numSeg: data.reduce((acc, item) => acc + item.numSeg, 0),
          numCalls: data.reduce((acc, item) => acc + item.numCalls, 0),
          timePerCall: data.reduce((acc, item) => acc + item.timePerCall, 0),
          numBet: data.reduce((acc, item) => acc + item.numBet, 0),
          timePerWager: data.reduce((acc, item) => acc + item.timePerWager, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="id">
          {groupByMap[groupBy]}
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="numSeg"
          dataFormat={durationReportFormatter}
        >
          Time
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="numCalls">
          Calls
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="timePerCall"
          dataFormat={durationReportFormatter}
        >
          Time per Call
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="numBet">
          Wagers
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="timePerWager"
          dataFormat={durationReportFormatter}
        >
          Time per Wager
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default SummaryCallActivity;
